import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '../../../auth/auth.guard';
import { BankingAccountCreateComponent } from './create/create.component';
import { BankingAccountEditComponent } from './edit/edit.component';
import { BankingAccountFormComponent } from './form/form.component';
import { BankingAccountListComponent } from './list/list.component';
import { BankingAccountService } from './banking-account.service';
import { BrowserModule } from '@angular/platform-browser';
import { ClientInterestUploadComponent } from './client-interest/upload.component';
import { FileUploadModule } from 'ng2-file-upload';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';

const routes: Routes = [
  {
    path: 'banking/accounts',
    component: BankingAccountListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'banking/accounts/create',
    component: BankingAccountCreateComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'banking/accounts/:id/edit',
    component: BankingAccountEditComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  declarations: [
    BankingAccountListComponent,
    BankingAccountCreateComponent,
    BankingAccountFormComponent,
    BankingAccountEditComponent,
    ClientInterestUploadComponent,
  ],
  imports: [
    FileUploadModule,
    BrowserModule,
    RouterModule,
    FormsModule,
    ModalModule,
    HttpClientModule,
    SharedModule,
    RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }),
  ],
  exports: [RouterModule],
  providers: [AuthGuard, BankingAccountService],
})
export class BankingAccountRoutingModule {}
